/** Tokens visuais — patrocinadores do evento (mesmo padrão dos recebimentos) */
export const PATROCINADORES_ACCENT = "#F96030";
export const PATROCINADORES_INK = "#1a2035";
export const PATROCINADORES_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";

export const patrocinadoresToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${PATROCINADORES_ACCENT}`,
};

export const patrocinadoresModalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 560,
};

export const patrocinadoresModalHeaderSx = {
  px: 2.5,
  py: 2,
  background: `linear-gradient(135deg, ${PATROCINADORES_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${PATROCINADORES_ACCENT}`,
};

export const patrocinadoresSectionSx = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
};

export const patrocinadoresFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
    minHeight: 44,
  },
};

export const patrocinadoresModalContentSx = {
  px: { xs: 2.5, sm: 3 },
  py: 2.5,
  overflow: "auto",
  boxSizing: "border-box",
  width: "100%",
};
